<template>
	  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex
      v-bind="{ [`xs${dashElm.flex}`]: true }"
      v-for = "dashElm in dashElements"
      :key = 'dashElm.title'
      >
      <v-card>
        <v-container fluid grid-list-lg>
          <v-layout row>
            <v-flex xs5>
              <div class='title' v-text='dashElm.title'>
              </div>
          </v-flex>
          <v-flex>
            <v-card-media
            :src='dashElm.src'
            height = '100px'
            contain
            >
          </v-card-media>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</v-flex>
</v-layout>
</v-container>
</template>
<script>
  export default {
    name: 'dashboard',
    data () {
      return {
        dashElements: [
          {
            title: 'News', flex: 4
          },
          {
            title: 'People and Contacts', flex: 4
          },
          {
            title: 'Calendar', felx: 4
          }
        ]
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/project/Dashboard.vue